import { render, staticRenderFns } from "./press.vue?vue&type=template&id=4a631d9b&scoped=true"
import script from "./press.vue?vue&type=script&lang=js"
export * from "./press.vue?vue&type=script&lang=js"
import style0 from "./press.vue?vue&type=style&index=0&id=4a631d9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a631d9b",
  null
  
)

export default component.exports